import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as SwitchCustomerIcon } from '@assets/svg/ic-switchCustomer.svg';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';
import Select from '@components/uikit/Select/Select';

import useResetAllFilters from '@hooks/useResetAllFilters';
import useTranslation from '@hooks/useTranslation';

import { useCustomerListQuery } from '@services/useCustomerListQuery';
import { useCustomerSetMutation } from '@services/useCustomerSetMutation';
import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const SwitchCustomerModal = () => {
  const navigate = useNavigate();
  const { resetAllFilter } = useResetAllFilters();
  const { t } = useTranslation();
  const { setModalClose } = useModalActions();

  const { mutate: customerSetMutate } = useCustomerSetMutation();
  const { data: customersData } = useCustomerListQuery();
  const { data: profileData } = useUserProfileQuery();

  const [changedCustomer, setChangedCustomer] = useState(false);
  const [newCustomer, setNewCustomer] = useState(profileData?.customer);

  const changeCustomer = () => {
    setChangedCustomer(true);
    navigate(`/customer/${newCustomer.customer_id}`, { state: 'SwitchCustomerModal' });
    customerSetMutate(
      { customer_id: newCustomer.customer_id },
      {
        onSuccess: () => {
          setTimeout(() => {
            setModalClose();
            setChangedCustomer(false);
          }, 1000);
          resetAllFilter();
        },
      },
    );
  };

  return (
    <div className={style.modalSwitchCustomer}>
      <ModalHeader />
      <div className={style.modalBody}>
        {changedCustomer ? (
          <>
            <SwitchCustomerIcon />
            <div className={style.changedCustomerTitle}>
              <div>{t('Customer')}</div>
              {t('has been successfully changed')}
            </div>
            <div className={style.changedCustomerInfo}>
              <label className={style.changedCustomerInfoLabel}>{t('Selected customer')}</label>
              <div className={style.changedCustomerInfoValue}>{newCustomer?.name || ''}</div>
            </div>
            <div className={style.changedCustomerFooter}>
              {t(
                'In a few seconds, the window will close and redirect you to the new customer analytics page.',
              )}
            </div>
          </>
        ) : (
          <>
            <div className={style.modalBodyTitle}>
              {t('Switch Customer')}
              <span className={style.extraText}>{t('Select a customer to view from the list below')}</span>
            </div>
            <Select
              label={t('Customers list')}
              value={newCustomer}
              onChange={setNewCustomer}
              options={customersData?.customers || []}
              itemKeys={{ valueFieldKey: 'customer_id', labelFieldKey: 'name' }}
              type={'woHelperText'}
              searchable
            />
          </>
        )}
      </div>
      {!changedCustomer && (
        <div className={style.modalFooter}>
          <Button type="primary" text={t('Save')} disabled={!newCustomer} onClick={changeCustomer} />
          <Button type="secondary" text={t('Cancel')} onClick={setModalClose} />
        </div>
      )}
    </div>
  );
};

export default SwitchCustomerModal;
